document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.bb').forEach(function (section) {
    var tiles = Array.from(section.querySelectorAll('.bb-tile'));
    var addButton = section.querySelector('[data-bb-add]');
    var compareEl = section.querySelector('[data-compare-total]');
    var saveEl = section.querySelector('[data-save-total]');
    var totalEl = section.querySelector('[data-final-total]');
    var steps = Array.from(section.querySelectorAll('.bb-step'));

    // Tracks tiles in the order they were selected (not DOM order), so that when two
    // selected tiles tie on price, we can tell which one was added most recently.
    var selectionOrder = tiles.filter(function (t) { return t.classList.contains('is-selected'); });

    var tierConfig = steps.map(function (s) {
      return {
        qty: parseInt(s.dataset.tierQty, 10),
        mode: s.dataset.tierMode,
        percent: parseInt(s.dataset.tierPercent, 10) || 0
      };
    });

    function getTier(count) {
      return tierConfig.find(function (t) { return t.qty === count; });
    }

    function formatMoney(cents) {
      return 'Rs. ' + (cents / 100).toFixed(2);
    }

    function recalc() {
      var selected = tiles.filter(function (t) { return t.classList.contains('is-selected'); });
      var prices = selected.map(function (t) { return parseInt(t.dataset.price, 10) || 0; });
      var count = selected.length;
      var compareTotal = prices.reduce(function (a, b) { return a + b; }, 0);
      var tier = getTier(count);
      var finalTotal = compareTotal;
      var saved = 0;

      if (tier) {
        if (tier.mode === 'percent') {
          var cheapestForPercent = prices.length ? Math.min.apply(null, prices) : 0;
          var discountAmount = Math.round(cheapestForPercent * (tier.percent / 100));
          finalTotal = compareTotal - discountAmount;
          saved = discountAmount;
        } else if (tier.mode === 'cheapest_free' && prices.length) {
          var cheapest = Math.min.apply(null, prices);
          finalTotal = compareTotal - cheapest;
          saved = cheapest;
        }
      }

      compareEl.textContent = (count && saved > 0) ? formatMoney(compareTotal) : '';
      saveEl.textContent = saved > 0 ? 'You Save ' + formatMoney(saved) : '';
      totalEl.textContent = formatMoney(finalTotal);

      // ---- "FREE" badge: on a price tie, the most recently selected tile wins,
      // not whichever comes first in the DOM. selectionOrder is chronological, and
      // using <= (rather than <) means a later tile with an equal price overrides
      // an earlier one during the reduce. ----
            // ---- reset every tile's discount display first, so a tile that no longer
      // qualifies (deselected, or tier changed) goes back to showing its plain price ----
      tiles.forEach(function (t) {
        t.classList.remove('is-free', 'is-percent-off');
        var priceEl = t.querySelector('[data-tile-price]');
        var compareEl2 = t.querySelector('[data-tile-price-compare]');
        if (priceEl) priceEl.textContent = formatMoney(parseInt(t.dataset.price, 10) || 0);
        if (compareEl2) compareEl2.textContent = '';
      });

      // ---- "FREE": on a price tie, the most recently selected tile wins, not
      // whichever comes first in the DOM — selectionOrder is chronological, and
      // <= (rather than <) means a later tile with an equal price overrides an
      // earlier one during the reduce. ----
      if (tier && tier.mode === 'cheapest_free' && selectionOrder.length) {
        var cheapestTile = selectionOrder.reduce(function (min, t) {
          var p = parseInt(t.dataset.price, 10) || 0;
          var minP = parseInt(min.dataset.price, 10) || 0;
          return p < minP ? t : min;
        }, selectionOrder[0]);
        cheapestTile.classList.add('is-free');

        var freeOrigPrice = parseInt(cheapestTile.dataset.price, 10) || 0;
        var freeCompareEl = cheapestTile.querySelector('[data-tile-price-compare]');
        if (freeCompareEl) freeCompareEl.textContent = formatMoney(freeOrigPrice);
      }

      // ---- PERCENT OFF: the cheaper of the (exactly 2) selected tiles shows its
      // original price struck through plus the discounted amount ----
      if (tier && tier.mode === 'percent' && selectionOrder.length) {
        var cheapestPercentTile = selectionOrder.reduce(function (min, t) {
          var p = parseInt(t.dataset.price, 10) || 0;
          var minP = parseInt(min.dataset.price, 10) || 0;
          return p < minP ? t : min;
        }, selectionOrder[0]);

        var origPrice = parseInt(cheapestPercentTile.dataset.price, 10) || 0;
        var discountedPrice = origPrice - Math.round(origPrice * (tier.percent / 100));

        cheapestPercentTile.classList.add('is-percent-off');
        var priceEl2 = cheapestPercentTile.querySelector('[data-tile-price]');
        var compareEl3 = cheapestPercentTile.querySelector('[data-tile-price-compare]');
        if (compareEl3) compareEl3.textContent = formatMoney(origPrice);
        if (priceEl2) priceEl2.textContent = formatMoney(discountedPrice);
      }

      var reachedQtys = tierConfig.filter(function (t) { return t.qty <= count; }).map(function (t) { return t.qty; });
      var nextTierQty = tierConfig
        .map(function (t) { return t.qty; })
        .filter(function (qty) { return qty > count; })
        .sort(function (a, b) { return a - b; })[0];

      steps.forEach(function (step) {
        var qty = parseInt(step.dataset.tierQty, 10);
        step.classList.toggle('is-reached', reachedQtys.indexOf(qty) !== -1);
        step.classList.toggle('is-next', qty === nextTierQty);
      });
    }

    // ---- each tile's available variants, parsed once ----
    var tileVariants = tiles.map(function (tile) {
      var script = tile.querySelector('[data-bb-variants]');
      try {
        return script ? JSON.parse(script.textContent) : [];
      } catch (e) {
        return [];
      }
    });

    function normalizeSizeLabel(label) {
      if (!label) return null;
      var t = label.trim().toLowerCase();
      if (t.indexOf('100ml') === 0 || t.indexOf('100 ml') === 0) return '100ml';
      if (t.indexOf('50ml') === 0 || t.indexOf('50 ml') === 0) return '50ml';
      return t;
    }

    // ---- swap every tile to the given size label (e.g. "50ml", "100ml Personalized") ----
    function applySizeToAllTiles(sizeLabel) {
      var target = normalizeSizeLabel(sizeLabel);
      if (!target) return;

      tiles.forEach(function (tile, i) {
        var match = tileVariants[i].find(function (v) {
          return normalizeSizeLabel(v.title) === target;
        });
        if (!match) return;

        tile.dataset.price = match.price;
        tile.dataset.variantId = match.id;

        var sizeEl = tile.querySelector('[data-tile-size]');
        var priceEl = tile.querySelector('[data-tile-price]');
        if (sizeEl) sizeEl.textContent = match.title;
        if (priceEl) priceEl.textContent = formatMoney(match.price);

        // Update price shown in the first tier only
        if (i === 0) {
          var tierPriceEl = section.querySelector('[data-bb-tier-price]');
          if (tierPriceEl) {
            tierPriceEl.textContent = formatMoney(match.price);
          }
        }
      });

      recalc();
    }

    function getCurrentPdpSize() {
      var input = document.querySelector('input[type="radio"][name="Size" i]:checked, select[name="Size" i]');
      return input ? input.value : null;
    }

    document.addEventListener('variant:change', function (e) {
      var variant = e.detail && e.detail.variant;
      if (variant && variant.title) applySizeToAllTiles(variant.title);
    });

    document.addEventListener('change', function (e) {
      var el = e.target;
      if (el && el.name && el.name.toLowerCase() === 'size') {
        applySizeToAllTiles(el.value);
      }
    });

    applySizeToAllTiles(getCurrentPdpSize());

    tiles.forEach(function (tile) {
      if (tile.dataset.locked === 'true') return;
      tile.addEventListener('click', function () {
        tile.classList.toggle('is-selected');

        if (tile.classList.contains('is-selected')) {
          selectionOrder.push(tile);
        } else {
          var idx = selectionOrder.indexOf(tile);
          if (idx !== -1) selectionOrder.splice(idx, 1);
        }

        recalc();
      });
    });

    if (addButton) {
      addButton.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var selected = tiles.filter(function (t) { return t.classList.contains('is-selected'); });
        if (!selected.length) return;

        var items = selected.map(function (t) {
          return { id: parseInt(t.dataset.variantId, 10), quantity: 1 };
        });

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (res) {
            if (!res.ok) return res.json().then(function (data) { throw new Error(data.description || 'Add to cart failed'); });
            return res.json();
          })
          .then(function () {
            return fetch('/cart.js').then(function (res) { return res.json(); });
          })
          .then(function (cart) {
            var drawer = document.querySelector('cart-drawer');

            if (drawer && typeof drawer.renderContents === 'function') {
              drawer.renderContents(cart);
            }

            if (drawer && typeof drawer.open === 'function') {
              drawer.open();
            } else if (drawer) {
              drawer.classList.remove('is-empty');
              drawer.removeAttribute('hidden');
            } else {
              window.location.href = '/cart';
            }
          })
          .catch(function (err) {
            console.error(err);
            alert('Could not add to cart: ' + err.message);
          });
      });
    }

    recalc();
  });
});
